import { useState } from "react";
import Registration from "./Registration";
import SignIn from "./SignIn";
import { ProfileButton } from "./styles";
import {
  ClickableLink,
  Container,
  Heading,
  accessControlAllowOrigin,
  envUrls,
  logSignOut,
} from "../../global";

const ProfilePage = ({ user, setUser }) => {
  const { email, username } = user;
  const [showSignUp, setShowSignUp] = useState(false);

  const signOut = async () => {
    setUser(JSON.parse(localStorage.getItem("DefaultUser")));
    localStorage.removeItem("SignedInUser");
    logSignOut();
    fetch(envUrls.signOut, {
      method: "GET",
      headers: {
        "Content-Type": "Application/json",
        "Access-Control-Allow-Origin": accessControlAllowOrigin,
      },
      credentials: "include",
    });
  };

  //Forgot password > new page
  //if user.username, show all details and then show delete user, change password, sign out

  return (
    <>
      {username ? (
        <Container
          $flexDirection={"column"}
          $justifyContent={"space-evenly"}
          style={{ height: "100%" }}
        >
          <Container
            $flex={1.5}
            $flexDirection={"column"}
            $gap={"7px"}
          ></Container>
          <Container $flex={3} $flexDirection={"column"} $gap={"7px"}>
            <Heading>Email: {email}</Heading>
            <Heading>Username: {username}</Heading>
            <ProfileButton onClick={signOut}>Sign Out</ProfileButton>
          </Container>
          <Container $flex={1} $flexDirection={"column"} $gap={"10px"}>
            <ClickableLink to={"change-password"} $size={"16px"}>
              Change Password
            </ClickableLink>
            <ClickableLink to={"delete-account"} $size={"16px"}>
              Delete Account
            </ClickableLink>
          </Container>
          <Container $flex={0.5} />
        </Container>
      ) : showSignUp ? (
        <Registration setShowSignUp={setShowSignUp} />
      ) : (
        <SignIn setShowSignUp={setShowSignUp} setUser={setUser} />
      )}
    </>
  );
};

export default ProfilePage;
